"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dataGridNewTrimmedTextRenderer = void 0;
const react_1 = __importDefault(require("react"));
const cells_1 = require("./..");
const dataGridNewTrimmedTextRenderer = ({ cellData, columnWidth, bold, disabled, inactive, headerJustify, tooltipMaxWidth }) => {
    if (cellData && columnWidth) {
        return (react_1.default.createElement(cells_1.DataGridNewCell, { cellData: cellData, columnWidth: columnWidth, bold: bold, disabled: disabled, inactive: inactive, contentJustify: headerJustify, tooltipMaxWidth: tooltipMaxWidth }));
    }
    return null;
};
exports.dataGridNewTrimmedTextRenderer = dataGridNewTrimmedTextRenderer;
//# sourceMappingURL=dataGridNewTrimmedTextRenderer.js.map